import { defineCustomElement } from 'vue';
import BrandingEmailPreview from '../web-components/branding-email-preview.ce.vue';

/**
 * The email pane of the branding preview is a real custom element: `.ce.vue` (the default in
 * `@vitejs/plugin-vue`) hands the SFC's styles to `defineCustomElement`, which injects them into
 * the element's shadow root. Shadow DOM is what isolates the two directions — the app's stylesheet
 * cannot restyle the replica, and the replica's stylesheet cannot restyle the app.
 */
const BrandingEmailPreviewElement = defineCustomElement(BrandingEmailPreview);

export default defineNuxtPlugin(() => {
  // HMR re-runs this module, and `customElements.define` throws on a tag that is already taken.
  if (!customElements.get('branding-email-preview')) {
    customElements.define('branding-email-preview', BrandingEmailPreviewElement);
  }
});

declare module 'vue' {
  interface GlobalComponents {
    /**
     * Template typing only: `isCustomElement` in `nuxt.config.ts` makes the compiler emit a
     * native element for this tag, so it is never resolved as a Vue component at runtime.
     */
    'branding-email-preview': typeof BrandingEmailPreview;
  }
}
